export const getAuth = (state) => state.auth || { initing: false, username: null, attributes: {} }
